import {createContext} from "react";

export default createContext({
	unitNames: [],
	loading: false,
	getUnitNames: () => {}
});